import { createSlice } from '@reduxjs/toolkit';
import { api } from '../api/api';

const initialState = {
  status: 'uninitialized',
  currentUser: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('forumAppToken');
      state.status = 'unauthenticated';
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(api.endpoints.login.matchFulfilled, (state) => {
      api.endpoints.getCurrentUser.initiate();
      state.status = 'pending';
    });
    builder.addMatcher(api.endpoints.getCurrentUser.matchPending, (state) => {
      state.status = 'pending';
    });
    builder.addMatcher(
      api.endpoints.getCurrentUser.matchFulfilled,
      (state, action) => {
        state.status = 'authenticated';
        state.currentUser = action.payload;
      }
    );
    builder.addMatcher(api.endpoints.getCurrentUser.matchRejected, (state) => {
      state.status = 'rejected';
      localStorage.removeItem('forumAppToken');
    });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
